// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  sort: string,
};

const boardSort = (state: State = { sort: 'popular' }, action: Action): State => {
  if (action.type === 'BOARD_SORT_TOGGLE') {
    return { sort: action.payload };
  }
  return state;
};

export default boardSort;
